export default __webpack_public_path__ + "static/media/socialfi-icon5.1eb8cd3e.png";